import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { InstallationsStore } from '@store';

@Component({
  selector: 'app-main-devices-list-small',
  templateUrl: './main-devices-list-small.component.html',
  styleUrls: ['./main-devices-list-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainDevicesListSmallComponent {
  @Input() installationId: number;

  constructor(public installationsStore: InstallationsStore) {}
}
